// Widget Scripts
import customTicketButton from './js/widgets/0-headerButton.js';
import mainSlideshow from './js/widgets/1-mainSlideshow.js';
import mainCards from './js/widgets/2-mainCards.js';
import autoEventFeed from './js/widgets/3A-autoEventFeed.js';
import signupFeature from './js/widgets/3B-signupFeature.js';
import seoWidget from './js/widgets/4-seoWidget.js';
import socialGallery from './js/widgets/5-socialGallery.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    mainCards();
    autoEventFeed();
    signupFeature();
    seoWidget();
    socialGallery();
  }
});
